module.exports = __webpack_public_path__ + "static/media/avolant.ce50d79a.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/climasense/aranha_roja_tomate/curativa/avolant.png
// module id = 2381
// module chunks = 3